export const FavoritesFilters = [
  {
    title: 'Все',
    name: 'all',
  },
  {
    title: 'Школы',
    name: 'school',
  },
  {
    title: 'Сады',
    name: 'gardens',
  },
];
